import React from 'react';
import { useMenuContent } from '../hooks/useMenuContent';
import contentService from '../services/contentService';

/**
 * Test page untuk verify contentService bekerja
 * Akses via: http://localhost:3000/test-content
 */
function TestContentPage() {
  const { sections, loading, error } = useMenuContent('homepage', true);
  const [apiTest, setApiTest] = React.useState(null);
  const [apiLoading, setApiLoading] = React.useState(false);

  const testDirectFetch = async () => {
    setApiLoading(true);
    try {
      const result = await contentService.getMenuContent('homepage', true);
      setApiTest({
        ok: true,
        count: result.length,
        data: result
      });
    } catch (err) {
      setApiTest({
        ok: false,
        error: err.message
      });
    }
    setApiLoading(false);
  };

  return (
    <div style={{ padding: '40px', fontFamily: 'monospace', maxWidth: '1200px' }}>
      <h1>🧪 Content Service Test</h1>

      <section style={{ marginBottom: '40px', padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
        <h2>Test 1: Direct API Call</h2>
        <button onClick={testDirectFetch} style={{ padding: '10px 20px', fontSize: '16px' }}>
          {apiLoading ? 'Testing...' : 'Run Test'}
        </button>
        {apiTest && (
          <pre style={{ 
            marginTop: '20px', 
            padding: '15px', 
            background: apiTest.ok ? '#e8f5e9' : '#ffebee',
            borderRadius: '4px',
            overflowX: 'auto'
          }}>
            {JSON.stringify(apiTest, null, 2)}
          </pre>
        )}
      </section>

      <section style={{ marginBottom: '40px', padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
        <h2>Test 2: Hook useMenuContent</h2>
        <div style={{ marginBottom: '15px' }}>
          <strong>Status:</strong> {loading ? '⏳ Loading...' : error ? '❌ Error' : '✅ Loaded'}
        </div>
        {error && (
          <div style={{ color: 'red', padding: '10px', background: '#ffebee', borderRadius: '4px' }}>
            Error: {error}
          </div>
        )}
        {sections.length > 0 && (
          <div>
            <p><strong>Sections found: {sections.length}</strong></p>
            <ul>
              {sections.map((section, idx) => (
                <li key={idx}>
                  <strong>{section.section_type}</strong> (section: {section.section})
                  <ul>
                    <li>status: {section.status}</li>
                    <li>id: {section.id}</li>
                    <li>content keys: {Object.keys(section.content || {}).join(', ')}</li>
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        )}
        {!loading && sections.length === 0 && !error && (
          <p style={{ color: '#999' }}>No sections loaded</p>
        )}
      </section>

      <section style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '8px', background: '#f5f5f5' }}>
        <h2>Raw sections data</h2>
        <pre style={{ 
          overflowX: 'auto',
          fontSize: '12px',
          maxHeight: '400px',
          overflowY: 'auto'
        }}>
          {JSON.stringify(sections, null, 2)}
        </pre>
      </section>
    </div>
  );
}

export default TestContentPage;
